import type { DeepPartial } from '@tryiris-ai/common.protojs';
import type { NativeTarget } from '@studio/models/control/preset';
import type { StudioDeviceControlPresetNativeTarget } from '@tryiris-ai/common.protojs/studio/v1/studio';
import type { T_Maybe } from '@tryiris-ai/js-types';

// One conversion boundary preserves opaque identifiers and their saved context.
export const jsNativeTargetToPb = (
  target: T_Maybe<NativeTarget>
): T_Maybe<DeepPartial<StudioDeviceControlPresetNativeTarget>> => {
  if (!target) {
    return undefined;
  }
  if (target.kind === 'visca_slot') {
    return { viscaSlot: target.slot, deviceId: target.deviceId };
  }
  return { onvifToken: target.token, profile: target.profile, deviceId: target.deviceId };
};

export const pbNativeTargetToJs = (
  pb: T_Maybe<{
    viscaSlot?: T_Maybe<number>;
    onvifToken?: T_Maybe<string>;
    profile?: T_Maybe<string>;
    deviceId?: T_Maybe<string>;
  }>
): T_Maybe<NativeTarget> => {
  if (!pb) {
    return undefined;
  }
  if (pb.onvifToken) {
    return {
      kind: 'onvif_token',
      token: pb.onvifToken,
      profile: pb.profile,
      deviceId: pb.deviceId
    };
  }
  if (pb.viscaSlot != null) {
    return { kind: 'visca_slot', slot: pb.viscaSlot, deviceId: pb.deviceId };
  }
  return undefined;
};
